import React from "react";
import { AlertTriangle } from "lucide-react";

export default function Disclaimer() {
    return (
        <div className="pt-32 pb-24" data-testid="disclaimer-page">
            <div className="max-w-3xl mx-auto px-6 md:px-12">
                <p className="text-pep-primary text-sm uppercase tracking-widest font-medium mb-3">Legal</p>
                <h1 className="font-heading text-5xl sm:text-6xl tracking-tighter text-pep-navy font-medium mb-6">
                    Research Use Disclaimer
                </h1>

                <div className="bg-amber-50 border-l-4 border-amber-500 rounded-2xl p-6 mb-12 flex gap-4">
                    <AlertTriangle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
                    <p className="text-amber-900 leading-relaxed">
                        <strong>FOR RESEARCH USE ONLY.</strong> Products sold by PepStep are intended strictly for in-vitro and laboratory research purposes. They are not intended for human or animal consumption, diagnostic, or therapeutic use.
                    </p>
                </div>

                <div className="space-y-8 text-pep-navy leading-relaxed">
                    <Section title="Customer Acknowledgement">
                        By placing an order with PepStep you acknowledge and agree that:
                        <ul className="list-disc pl-6 mt-3 space-y-2 text-pep-muted">
                            <li>You are purchasing the products for <strong>research purposes only</strong>.</li>
                            <li>You will <strong>not</strong> administer, consume, ingest, inject, inhale, or otherwise introduce these products into the body of any human being or animal.</li>
                            <li>You will store, handle, and dispose of all products in accordance with proper laboratory safety practices and applicable laws and regulations.</li>
                            <li>You assume full responsibility for the safe and lawful use of these products and indemnify PepStep against any claim or liability arising from misuse.</li>
                        </ul>
                    </Section>
                    <Section title="No Medical Claims">
                        PepStep makes no claims regarding the safety, efficacy, or suitability of these products for any specific use other than legitimate scientific research. Any literature provided alongside our products is for educational reference and does not constitute medical advice.
                    </Section>
                    <Section title="Regulatory Status">
                        Our products are not approved by the Therapeutic Goods Administration (TGA), the U.S. Food and Drug Administration (FDA), or any other regulatory authority for use as a drug or medicinal product. They have not been evaluated for human safety.
                    </Section>
                    <Section title="Lab-Tested Purity">
                        All products on PepStep are independently tested by third-party laboratories for purity and identity. Certificates of Analysis are available on request at <a href="mailto:orders@pepstep.com" className="text-pep-primary hover:underline">orders@pepstep.com</a>.
                    </Section>
                </div>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <div>
            <h2 className="font-heading text-2xl font-medium text-pep-navy mb-3">{title}</h2>
            <div className="text-pep-muted">{children}</div>
        </div>
    );
}
